import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orders: [],
  counts: {},
  pagination: {
    count: 0,
    currentPage: 1,
    hasNext: false,
    hasPrevious: false,
    totalPages: 0,
  },
  orderDetails: null,
  loading: false,
  detailsLoading: false,
  error: null,
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setOrders: (state, action) => {
      state.orders = action.payload.results || [];
      state.counts = action.payload.counts || {};
      state.pagination = {
        count: action.payload.count || 0,
        currentPage: action.payload.currentPage || 1,
        hasNext: !!action.payload.next,
        hasPrevious: !!action.payload.previous,
        totalPages: Math.ceil((action.payload.count || 0) / 10),
      };
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearOrders: (state) => {
      state.orders = [];
      state.counts = {};
      state.pagination = {
        count: 0,
        currentPage: 1,
        hasNext: false,
        hasPrevious: false,
        totalPages: 0,
      };
      state.loading = false;
      state.error = null;
    },
    updateOrderApproval: (state, action) => {
      const { orderId, approved, shipment_status } = action.payload;
      const order = state.orders.find((o) => o.order_id === orderId);
      if (order) {
        order.is_approved = approved;
        order.shipment_status = shipment_status;
      }
      if (state.orderDetails && state.orderDetails.order_id === orderId) {
        state.orderDetails.is_approved = approved;
        state.orderDetails.shipment_status = shipment_status;
      }
    },
    setOrderDetails: (state, action) => {
      state.orderDetails = action.payload;
      state.detailsLoading = false;
      state.error = null;
    },
    setDetailsLoading: (state, action) => {
      state.detailsLoading = action.payload;
    },
    updateOrderPaymentStatus: (state, action) => {
      const { orderId, paymentStatus, webhookReceived, isApproved, shipmentStatus } = action.payload;
      const order = state.orders.find((o) => o.order_id === orderId);
      if (order) {
        order.payment_status = paymentStatus;
        if (webhookReceived !== undefined) {
          order.webhook_recieved = webhookReceived;
        }
        if (isApproved !== undefined) {
          order.is_approved = isApproved;
        }
        if (shipmentStatus !== undefined) {
          order.shipment_status = shipmentStatus;
        }
      }
      if (state.orderDetails && state.orderDetails.order_id === orderId) {
        state.orderDetails.payment_status = paymentStatus;
        if (webhookReceived !== undefined) {
          state.orderDetails.webhook_recieved = webhookReceived;
        }
        if (isApproved !== undefined) {
          state.orderDetails.is_approved = isApproved;
        }
        if (shipmentStatus !== undefined) {
          state.orderDetails.shipment_status = shipmentStatus;
        }
      }
    },
  },
});

export const {
  setOrders,
  setLoading,
  setError,
  clearOrders,
  updateOrderApproval,
  setOrderDetails,
  setDetailsLoading,
  updateOrderPaymentStatus,
} = orderSlice.actions;
export default orderSlice.reducer;
